var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowCounterClockwiseClockStroke = function SvgIconArrowCounterClockwiseClockStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24 9.334c8.099 0 14.667 6.568 14.667 14.667S32.099 38.667 24 38.667q-.094-.002-.187-.005l.028-2.265.159.003c6.837 0 12.4-5.562 12.4-12.399s-5.563-12.4-12.4-12.4S11.6 17.164 11.6 24c0 3.19 1.212 6.103 3.2 8.302.595.658 1.596.19 1.598-.697l.005-4.939h2.264v10.667H8.009L8 35.064h4.596c.616 0 .924-.79.511-1.249a14.6 14.6 0 0 1-3.774-9.814c0-8.099 6.568-14.667 14.667-14.667M23.888 24.4h5.445v2.267H24.41a2.666 2.666 0 0 1-2.575-3.357l2.262-8.643h2.347z",
    clipRule: "evenodd"
  })));
};
export default SvgIconArrowCounterClockwiseClockStroke;